<template>
  <guest-layout background-class="bg-white" :color-scheme="'light'" :poper-absolute="true">
    <main>
      <div class="relative isolate">
        <svg class="absolute inset-x-0 top-0 -z-10 h-[64rem] w-full stroke-gray-200 [mask-image:radial-gradient(32rem_32rem_at_center,white,transparent)]" aria-hidden="true">
          <defs>
            <pattern id="1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84" width="200" height="200" x="50%" y="-1" patternUnits="userSpaceOnUse">
              <path d="M.5 200V.5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y="-1" class="overflow-visible fill-gray-50">
            <path d="M-200 0h201v201h-201Z M600 0h201v201h-201Z M-400 600h201v201h-201Z M200 800h201v201h-201Z" stroke-width="0" />
          </svg>
          <rect width="100%" height="100%" stroke-width="0" fill="url(#1f932ae7-37de-4c0a-a8b0-a6e3b4d44b84)" />
        </svg>
        <div class="absolute left-1/2 right-0 top-0 -z-10 -ml-24 transform-gpu overflow-hidden blur-3xl lg:ml-24 xl:ml-48" aria-hidden="true">
          <div class="aspect-[801/1036] w-[50.0625rem] bg-gradient-to-tr from-[#0AFFA9] to-[#00E091] opacity-10" style="clip-path: polygon(63.1% 29.5%, 100% 17.1%, 76.6% 3%, 48.4% 0%, 44.6% 4.7%, 54.5% 25.3%, 59.8% 49%, 55.2% 57.8%, 44.4% 57.2%, 27.8% 47.9%, 35.1% 81.5%, 0% 97.7%, 39.2% 100%, 35.2% 81.4%, 97.2% 52.8%, 63.1% 29.5%)" />
        </div>
        <div class="overflow-hidden">
          <div class="mx-auto max-w-7xl px-6 pb-32 pt-36 sm:pt-60 lg:px-8 lg:pt-32">
            <div class="mx-auto max-w-2xl gap-x-14 lg:mx-0 lg:flex lg:max-w-none lg:items-center">
              <div class="w-full max-w-xl lg:shrink-0 xl:max-w-2xl">
                <h1 class="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">{{ __('The highest quality on all levels: LIVCK Branding') }}</h1>
                <p class="relative mt-6 text-lg leading-8 text-gray-600 sm:max-w-md lg:max-w-none">{{ __('Considering the following points, you can integrate our logo and wordmark into your own app:') }}</p>
                <dl class="mt-5 max-w-xl space-y-4 text-base leading-7 text-gray-600 lg:max-w-none">
                  <dt class="flex gap-x-3 items-center" v-for="g in ['The logo may not be changed.', 'The colors may not be changed.', 'The logo must not be distorted or reconfigured.']">
                    <svg class="flex-none text-primary" width="14" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="flex-1 font-medium text-sm">{{ __(g) }}</span>
                  </dt>
                </dl>
              </div>
              <div class="mx-auto mt-14 lg:block hidden">
                <svg v-motion-up-down class="w-[16rem] h-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.77 47.31"><path fill="#00e091" d="M107.13,27.12l-7.08,28.71a1,1,0,0,1-1.93,0l-1.59-6.41a1,1,0,0,0-1-.75H84.44a1,1,0,0,0-1,1.28l6.93,23a1,1,0,0,0,1,.71h15.07a1,1,0,0,0,1-.71l13.79-45.32a1,1,0,0,0-1-1.28H108.09A1,1,0,0,0,107.13,27.12Z" transform="translate(-83.45 -26.36)"/></svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white py-24 sm:py-32 z-50">
        <div class="relative mx-auto max-w-7xl px-6">
          <div class="grid grid-cols-1 items-center gap-x-8 gap-y-16 lg:grid-cols-2">
            <div class="mx-auto w-full max-w-xl lg:mx-0">
              <h2 class="text-3xl font-bold tracking-tight text-gray-900">Logo and Wordmark</h2>
              <p class="mt-6 text-lg leading-8 text-gray-600">{{ __('Here are some logo and wordmark combinations in dark and light styles. The different variations have been carefully designed to look legible and appealing on different backgrounds.') }}</p>
<!--              <div class="mt-8 flex items-center gap-x-6">-->
<!--                <a href="#" class="rounded-md bg-primary-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">{{ __('Download Media-Pack') }}</a>-->
<!--              </div>-->
            </div>
            <div class="mx-auto grid w-full max-w-xl grid-cols-1 md:grid-cols-2 items-center gap-x-4 gap-y-4 lg:mx-0 lg:max-w-none lg:pl-8">
              <div v-for="media in assets" class="group relative mx-auto h-24 w-full border border-gray-100 rounded-md bg-gray-500/20">
                <img :alt="media.name" draggable="false" :src="asset(media.src)" class="absolute p-6 inset-0 h-full w-full flex justify-center items-center">
                <div class="absolute bottom-0 right-0 space-x-2 flex text-sm font-medium px-2 pb-0.5 hidden group-hover:flex">
                  <button @click="download(asset(media.src), media.name)" class="text-gray-900 hover:text-primary transition duration-300 cursor-pointer">Download</button>
                  <button @click="copyToClipboard(asset(media.src))" class="text-gray-900 hover:text-primary transition duration-300 cursor-pointer">Link</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white py-24 sm:py-32">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
          <div class="mx-auto max-w-2xl lg:max-w-none">
            <div class="text-center">
              <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ __('Colors') }}</h2>
              <p class="mt-4 text-lg leading-8 text-gray-600">{{ __('Here you can find the colors we used at LIVCK around our website, logos & status page. ') }}</p>
            </div>
            <dl class="mt-16 grid grid-cols-1 overflow-hidden rounded-2xl text-center sm:grid-cols-2 lg:grid-cols-4 border border-gray-300">
              <div v-for="color in colors" :key="color.code" class="flex flex-col bg-gray-400/5 p-8" :style="{'background-color': color.code}">
                <dt class="text-sm font-semibold leading-6 opacity-90" :class="[color.className]">{{ color.name }}</dt>
                <dd class="order-first text-3xl font-semibold tracking-tight" :class="[color.className]">{{ color.code.toUpperCase() }}</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>

    </main>
  </guest-layout>
</template>

<script setup>
import GuestLayout from "@/Layouts/GuestLayout";

const assets = [
  {
    name: 'LIVCK Wordmark (Dark)',
    src: 'build/brand/wordmark.svg',
  },
  {
    name: 'LIVCK Wordmark (Light)',
    src: 'build/brand/wordmark-light.svg',
  },
  {
    name: 'LIVCK Inline-Wordmark (Dark)',
    src: 'build/brand/inline-wordmark-dark.svg',
  },
  {
    name: 'LIVCK Inline-Wordmark (Light)',
    src: 'build/brand/inline-wordmark-light.svg',
  },
  {
    name: 'LIVCK Icon (Primary)',
    src: 'build/brand/icon.svg',
  },
  {
    name: 'LIVCK Icon (Light)',
    src: 'build/brand/icon-light.svg',
  }
];

const colors = [
  {
    name: 'Primary',
    code: '#00e091',
    className: 'text-white',
  },
  {
    name: 'White',
    code: '#ffffff',
    className: 'text-black',
  },
  {
    name: 'Black',
    code: '#0f192a',
    className: 'text-white',
  },
  {
    name: 'Red',
    code: '#EF4444',
    className: 'text-white',
  },
];

function download(url, filename) {
  fetch(url)
      .then(response => response.text())
      .then(svgContent => {
        const blob = new Blob([svgContent], { type: 'image/svg+xml' });
        const url = URL.createObjectURL(blob);

        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename || 'download.svg';
        anchor.click();

        // Cleanup
        URL.revokeObjectURL(url);
      })
      .catch(error => console.error('Error downloading SVG:', error));
}
</script>